import { IViewerFloor } from "../../../interfaces/IViewerFloor";
import { FloorSelectionExtensionOptions } from "./floorSelectionExtensionOptions";
import { FloorSelectorButton } from "./FloorSelectorButton";

export class FloorSelectorToolbar {
	public subToolbar: Autodesk.Viewing.UI.ControlGroup;
	public activeFloorButton?: FloorSelectorButton;

	public constructor(public options: FloorSelectionExtensionOptions, public floorToolBar: Autodesk.Viewing.UI.ToolBar) {}

	public builtToolbarAsync(activeFloorLevel: number): Promise<void> {
		throw new Error("Not implemented in base class");
	}

	public activateFloor(button: FloorSelectorButton): void {
		if (this.activeFloorButton != null) {
			this.activeFloorButton.active = false;
		}
		this.activeFloorButton = button;
		button.active = true;
	}

	public createToolbarButton(subToolbar: Autodesk.Viewing.UI.ControlGroup, vf: IViewerFloor, buttonCallbacks: {}): FloorSelectorButton {
		const floor = vf.floor;
		const button = new FloorSelectorButton(
			`${this.options.autodeskContainerId}-switch-floor-${floor.level}`,
			floor.level.toString(),
			floor.level
		);

		button.onClick = async (): Promise<void> => {
			this.options.onFloorChangedAsync(vf);

			this.activateFloor(button);
			await this.builtToolbarAsync(button.floorLevel);
		};

		buttonCallbacks[floor.level] = () => this.activateFloor(button);

		subToolbar.addControl(button);

		return button;
	}
}
